import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const LIST_INVESTMENT_THEMES_API = 'INVESTCORE/LIST_INVESTMENT_THEMES_API';
const GET_INVESTMENT_THEME_API = 'INVESTCORE/GET_INVESTMENT_THEME_API';
const CREATE_INVESTMENT_THEME_API = 'INVESTCORE/CREATE_INVESTMENT_THEME_API';
const UPDATE_INVESTMENT_THEME_API = 'INVESTCORE/UPDATE_INVESTMENT_THEME_API';
const DELETE_INVESTMENT_THEME_API = 'INVESTCORE/DELETE_INVESTMENT_THEME_API';

const LIST_INVESTMENT_THEME_CATEGORIES_API = 'INVESTCORE/LIST_INVESTMENT_THEME_CATEGORIES_API';
const CREATE_INVESTMENT_THEME_CATEGORY_API = 'INVESTCORE/CREATE_INVESTMENT_THEME_CATEGORY_API';
const UPDATE_INVESTMENT_THEME_CATEGORY_API = 'INVESTCORE/UPDATE_INVESTMENT_THEME_CATEGORY_API';
const DELETE_INVESTMENT_THEME_CATEGORY_API = 'INVESTCORE/DELETE_INVESTMENT_THEME_CATEGORY_API';

// params: status, asset_type, category_id, search
export const listInvestmentThemesApiCall = createApiCall(
  LIST_INVESTMENT_THEMES_API,
  params => ({
    endpoint: generateEndpoint({ host: '/api/admin/investment-themes', params }),
    method: 'GET',
  })
);

export const getInvestmentThemeApiCall = createApiCall(
  GET_INVESTMENT_THEME_API,
  ({ id }) => ({
    endpoint: `/api/admin/investment-themes/${id}`,
    method: 'GET',
  })
);

export const createInvestmentThemeApiCall = createApiCall(
  CREATE_INVESTMENT_THEME_API,
  body => ({
    endpoint: '/api/admin/investment-themes',
    method: 'POST',
    body,
    notify: true,
  })
);

export const updateInvestmentThemeApiCall = createApiCall(
  UPDATE_INVESTMENT_THEME_API,
  ({ id, ...body }) => ({
    endpoint: `/api/admin/investment-themes/${id}`,
    method: 'PUT',
    body,
    notify: true,
  })
);

export const deleteInvestmentThemeApiCall = createApiCall(
  DELETE_INVESTMENT_THEME_API,
  ({ id }) => ({
    endpoint: `/api/admin/investment-themes/${id}`,
    method: 'DELETE',
    notify: true,
  })
);

export const listInvestmentThemeCategoriesApiCall = createApiCall(
  LIST_INVESTMENT_THEME_CATEGORIES_API,
  () => ({
    endpoint: '/api/admin/investment-theme-categories',
    method: 'GET',
  })
);

export const createInvestmentThemeCategoryApiCall = createApiCall(
  CREATE_INVESTMENT_THEME_CATEGORY_API,
  body => ({
    endpoint: '/api/admin/investment-theme-categories',
    method: 'POST',
    body,
    notify: true,
  })
);

export const updateInvestmentThemeCategoryApiCall = createApiCall(
  UPDATE_INVESTMENT_THEME_CATEGORY_API,
  ({ id, ...body }) => ({
    endpoint: `/api/admin/investment-theme-categories/${id}`,
    method: 'PUT',
    body,
    notify: true,
  })
);

export const deleteInvestmentThemeCategoryApiCall = createApiCall(
  DELETE_INVESTMENT_THEME_CATEGORY_API,
  ({ id }) => ({
    endpoint: `/api/admin/investment-theme-categories/${id}`,
    method: 'DELETE',
    notify: true,
  })
);
